import { memo } from 'react';

import { makerCoinCode } from '../../utils/common';

interface Props {
  value: string
}

const CoinName = (props: Props) => {
  const coinName = makerCoinCode(props.value).default
  return <>{coinName}</>;
};

export default memo(CoinName);
